
import Accordion from './Accordion';
import BusRatesTable from './BusRatesTable';
import CustomCarousel from './CustomCarousel';
import Gallery from './Smallimages';
import './smallkey.css';
import { Helmet } from 'react-helmet';

function Ecofriendlyresortinnagpurdistrict() {



  const cardData =
  {
    keyword: ' Eco-Friendly Resort in Nagpur District',
    heading:  'Woodland Escape: Eco-Friendly Resort in Nagpur District ',
    headingDescription: 'Woodland Escape Resort stands out as an eco-friendly resort in Nagpur District, thoughtfully designed to harmonise with its natural surroundings and minimise environmental impact while offering comfort and tranquility. Set within lush forest-fringed grounds, the resort integrates green practices—such as natural landscaping, nature-emphasised layouts and a focus on rejuvenation amid greenery—to create a stay that feels restorative and earth-aware. Guests can relax on open lawns, take gentle nature walks, and enjoy the resort’s commitment to wellness and environmental care, all while staying in comfortable cottages and receiving warm hospitality. Whether you’re looking for a weekend nature retreat or a longer escape, Woodland Escape Resort offers a serene, sustainable experience in the heart of Nagpur’s countryside.',

    top: 'Top Activities of Woodland Escape Resort Near Nagpur',
   "topPlaces": [
  {
    "title": "Forest Retreat Stay Experience",
    "description": "Woodland Escape Resort offers a serene getaway surrounded by dense forests, misty hills, and soothing sounds of nature. Guests wake up to the melodies of chirping birds and the cool fragrance of dewy mornings. The resort blends rustic charm with modern elegance, creating an ambiance of true peace and comfort. Every corner reflects nature’s simplicity, encouraging travelers to disconnect from the city rush. Whether you’re lounging on the porch with a cup of tea or strolling through the green pathways, the stay promises calmness and clarity. It’s a retreat where you can breathe freely, unwind deeply, and reconnect with your natural rhythm."
  },
  {
    "title": "Luxury Cottages Amid Nature",
    "description": "The resort’s cottages are thoughtfully crafted to provide an authentic forest-luxury experience. Each cottage is built using eco-friendly materials and designed to offer panoramic views of the surrounding woods. Inside, guests enjoy spacious interiors, cozy bedding, and all modern amenities while staying close to nature’s essence. The gentle hum of the forest replaces city noise, offering a deeply restful environment. From sunrise reflections on your balcony to starry skies at night, every moment here feels timeless. Families, couples, and solo travelers alike find these cottages perfect for soulful relaxation amidst nature’s raw beauty."
  },
  {
    "title": "Wildlife and Tiger Safari",
    "description": "Adventure seekers can experience the thrill of the wild through guided tiger safaris organized near the resort. The region’s dense forests are home to majestic tigers, deer, peacocks, and countless species of birds. Expert naturalists accompany visitors, ensuring a safe and educational journey through the jungle. Each safari offers an adrenaline rush mixed with awe as you witness the raw beauty of wildlife in its natural habitat. The early morning and evening safaris are especially magical, when golden sunlight filters through the trees and animals emerge from their hiding places. It’s an unforgettable adventure that connects you to the untamed heart of nature."
  },
  {
    "title": "Nature Trails and Jungle Walks",
    "description": "For those who prefer calm exploration, Woodland Escape Resort’s nature trails offer the perfect adventure. Meandering paths take guests through wildflowers, bamboo groves, and hidden forest streams. Every step reveals something new — a bird call, a butterfly dance, or the gentle rustle of leaves. Guided jungle walks help you learn about the region’s biodiversity and plant life. It’s not just a walk; it’s an immersion into a living ecosystem that refreshes the mind and body. The experience is ideal for photographers, nature lovers, and families who want to reconnect with the wonders of the natural world."
  },
  {
    "title": "Campfire and Barbecue Nights",
    "description": "As dusk settles over the forest, Woodland Escape Resort transforms into a magical open-air lounge. Guests gather around the crackling bonfire, sharing laughter and stories under a canopy of stars. The aroma of freshly grilled barbecue fills the air, accompanied by light music and soft forest winds. Whether you’re roasting marshmallows with family or joining a live music night, the warmth of the fire unites everyone in celebration. This nightly ritual captures the essence of togetherness — blending fun, relaxation, and nature’s comfort into one unforgettable evening experience."
  },
  {
    "title": "Adventure and Outdoor Games",
    "description": "Beyond peaceful moments, the resort also offers a range of exciting outdoor adventures. Guests can try their hands at archery, cycling through forest trails, or rope-climbing challenges. A well-equipped outdoor arena allows for group sports like volleyball, cricket, and badminton. For thrill-seekers, there are guided treks and obstacle courses designed for team-building. Each activity encourages bonding, laughter, and energy in the fresh, open air. Whether you’re a corporate group or a family on vacation, the balance of fun and fitness ensures every guest finds their own rhythm of adventure."
  },
  {
    "title": "Farm-to-Table Dining Experience",
    "description": "Dining at Woodland Escape Resort is a celebration of freshness and local flavor. The restaurant follows a true farm-to-table concept, using ingredients sourced from nearby farms and organic gardens. Traditional Maharashtrian and regional delicacies are prepared with authentic recipes and served in an inviting outdoor dining area. Every meal tells a story — of farmers, tradition, and sustainability. The aroma of home-cooked food mingles with the crisp forest air, creating a soulful dining experience. Guests can even participate in small cooking sessions or farm tours to see where their food comes from."
  },
  {
    "title": "Peaceful Meditation and Yoga Zone",
    "description": "For those seeking inner peace, the resort’s meditation and yoga zone offers the perfect sanctuary. Set amidst greenery and birdsong, this space allows guests to practice mindfulness in complete harmony with nature. Morning yoga sessions at sunrise and guided evening meditations under the open sky restore balance and positivity. The calm surroundings, fresh oxygen, and gentle breezes make every breath rejuvenating. Many guests describe it as a spiritual escape where body, mind, and soul realign. Whether you’re an experienced yogi or a beginner, this serene corner helps you rediscover your inner calm."
  }
],



"services": [
    {
      "name": "Eco-Friendly Resort in Nagpur District",
      "description": "Experience sustainable luxury at this eco-friendly resort in Nagpur district, surrounded by lush greenery and pristine natural landscapes. Designed with environmentally conscious practices, the resort features solar-powered lighting, rainwater harvesting, and organic gardens. Guests can enjoy serene nature walks, riverside picnics, and outdoor activities while staying in comfortable eco-friendly accommodations, making it perfect for families, couples, and nature enthusiasts."
    },
    {
      "name": "Nagpur Green Resort",
      "description": "Nagpur Green Resort offers a tranquil escape in the heart of nature with minimal environmental impact. Guests can relax in green-certified villas, explore the surrounding forest trails, enjoy outdoor yoga sessions, and participate in eco-activities. Ideal for those seeking a rejuvenating stay while staying mindful of sustainability."
    },
    {
      "name": "Nagpur Sustainable Nature Resort",
      "description": "Stay at Nagpur Sustainable Nature Resort and experience harmony with nature. The resort uses sustainable building materials, promotes zero-waste practices, and sources organic local food. Guests can enjoy guided nature walks, bird watching, and outdoor adventure activities, making it perfect for eco-conscious travelers and families seeking a peaceful retreat."
    },
    {
      "name": "Nagpur Eco Luxury Stay",
      "description": "Nagpur Eco Luxury Stay combines high-end comfort with eco-friendly practices. With luxurious villas, private balconies overlooking nature, and a serene environment, guests can enjoy spa treatments, poolside relaxation, and adventure activities like trekking and kayaking. Sustainability is integrated seamlessly without compromising on luxury."
    },
    {
      "name": "Nagpur Forest Eco Resort",
      "description": "Immerse yourself in nature at Nagpur Forest Eco Resort, nestled amidst dense forests. The resort features tree-top accommodations, forest trails, and eco-friendly dining options. Guests can enjoy wildlife spotting, guided hikes, and evening campfires, making it an ideal getaway for families, couples, and nature lovers."
    },
    {
      "name": "Nagpur Riverside Eco Resort",
      "description": "Nagpur Riverside Eco Resort offers a peaceful retreat along the banks of a river. With eco-friendly cottages, outdoor seating, and nature-inspired amenities, guests can enjoy riverside walks, kayaking, and poolside relaxation. This resort is perfect for families, couples, and small groups seeking an eco-conscious stay."
    },
    {
      "name": "Nagpur Adventure Eco Resort",
      "description": "Combine sustainability with adventure at Nagpur Adventure Eco Resort. Guests can enjoy zip-lining, rock climbing, trekking, and cycling, all within an eco-friendly environment. The resort emphasizes responsible tourism while providing a thrilling and safe experience for families, friends, and adventure enthusiasts."
    },
    {
      "name": "Nagpur Family Eco Resort",
      "description": "Nagpur Family Eco Resort is designed for eco-conscious families seeking a fun and relaxing vacation. It offers kid-friendly eco activities, swimming in natural pools, organic meals, and nature walks. Families can enjoy group activities while teaching children the value of sustainable living in a scenic natural setting."
    },
    {
      "name": "Nagpur Kids Friendly Eco Resort",
      "description": "Perfect for families with children, Nagpur Kids Friendly Eco Resort combines sustainability with fun. The resort features eco-playgrounds, guided nature trails, educational activities about the environment, and safe swimming areas. Kids can learn about nature while having an enjoyable and memorable experience."
    },
    {
      "name": "Nagpur Jungle Eco Resort",
      "description": "Nagpur Jungle Eco Resort offers a unique jungle experience with eco-friendly accommodations. Guests can explore jungle trails, spot wildlife, enjoy outdoor dining, and relax in tree-top or riverside cottages. The resort is ideal for nature lovers, couples, and families looking for an immersive eco-friendly jungle experience."
    },
    {
      "name": "Nagpur Weekend Eco Resort",
      "description": "Escape the city for a weekend at Nagpur Weekend Eco Resort. Guests can enjoy eco-friendly cottages, organic meals, riverside relaxation, trekking, and nature activities. Weekend packages are designed for families, couples, and friends seeking a short, rejuvenating break in a natural setting."
    },
    {
      "name": "Nagpur Booking Eco-Friendly Resort",
      "description": "Plan your stay at Nagpur Booking Eco-Friendly Resort, offering simple online booking for eco-conscious travelers. Guests can reserve private eco-villas, cottages with forest or river views, and enjoy guided tours, sustainable meals, and outdoor activities, all with minimal environmental impact."
    },
    {
      "name": "Nagpur Hill Eco Resort",
      "description": "Set on scenic hills, Nagpur Hill Eco Resort offers panoramic views, eco-friendly villas, and sustainable practices. Guests can enjoy hill trekking, bird watching, sunset viewpoints, and outdoor dining, making it ideal for couples, families, and nature enthusiasts seeking a peaceful getaway."
    },
    {
      "name": "Nagpur Private Eco Stay",
      "description": "Nagpur Private Eco Stay provides exclusive villas and cottages for guests seeking privacy along with sustainability. Each accommodation is designed with eco-conscious materials, natural decor, and private outdoor spaces, offering a serene retreat for couples, families, and small groups."
    },
    {
      "name": "Nagpur Nature-Friendly Resort",
      "description": "Nagpur Nature-Friendly Resort emphasizes eco-tourism and comfort. Guests can enjoy natural landscaping, organic meals, guided nature walks, and wildlife spotting. This resort is perfect for travelers who want to connect with nature, relax, and experience eco-luxury without compromising sustainability."
    }
  ],
  "tableData": [
    ["- Eco-Friendly Resort in Nagpur District", "- Nagpur Green Resort"],
    ["- Nagpur Sustainable Nature Resort", "- Nagpur Eco Luxury Stay"],
    ["- Nagpur Forest Eco Resort", "- Nagpur Riverside Eco Resort"],
    ["- Nagpur Adventure Eco Resort", "- Nagpur Family Eco Resort"],
    ["- Nagpur Kids Friendly Eco Resort", "- Nagpur Jungle Eco Resort"],
    ["- Nagpur Weekend Eco Resort", "- Nagpur Booking Eco-Friendly Resort"],
    ["- Nagpur Hill Eco Resort", "- Nagpur Private Eco Stay"],
    ["- Nagpur Nature-Friendly Resort", ""]
  ],
  

whychoose: [
  {
    "WhyChooseheading": "Sustainable Eco-Friendly Resort in Nagpur District",
    "WhyChoosedescription": "Woodland Escape Resort emphasizes eco-conscious living while offering a luxurious stay. Surrounded by lush forests and greenery, the resort integrates sustainability into its design, providing guests with an environmentally responsible retreat."
  },
  {
    "WhyChooseheading": "Harmony with Nature",
    "WhyChoosedescription": "The resort is designed to blend seamlessly with its natural surroundings. From green landscaping to minimal-impact construction, guests can experience a peaceful environment where nature is preserved and celebrated."
  },
  {
    "WhyChooseheading": "Energy-Efficient & Green Practices",
    "WhyChoosedescription": "Woodland Escape Resort uses renewable energy, water conservation systems, and waste management practices to reduce its ecological footprint. Guests enjoy modern comforts while knowing their stay supports sustainability."
  },
  {
    "WhyChooseheading": "Organic and Locally Sourced Meals",
    "WhyChoosedescription": "The resort provides fresh, locally sourced, and organic meals. Dining at Woodland Escape means enjoying nutritious food that supports local farmers and reduces environmental impact."
  },
  {
    "WhyChooseheading": "Nature Trails and Outdoor Activities",
    "WhyChoosedescription": "Eco-friendly activities like guided forest walks, birdwatching, cycling, and pond-side relaxation allow guests to immerse themselves in nature responsibly. Families and couples can learn about the local ecosystem while having fun."
  },
  {
    "WhyChooseheading": "Comfortable and Green Accommodation",
    "WhyChoosedescription": "Rooms and cottages are thoughtfully designed to minimize environmental impact while maximizing comfort. Eco-friendly materials, natural ventilation, and forest-facing views create a serene and sustainable stay."
  },
  {
    "WhyChooseheading": "Accessible Yet Serene Location",
    "WhyChoosedescription": "Located conveniently in Nagpur District, Woodland Escape Resort offers an eco-conscious retreat without long travel. Guests can enjoy a peaceful, green getaway while being close to the city."
  }
]






























  }

const faqData = [
  {
    question: "Why choose Woodland Escape Resort as an eco‑friendly resort in Nagpur district?",
    answer: "Woodland Escape Resort offers a sustainable stay in Nagpur district, combining comfortable accommodations with nature‑conscious practices. Surrounded by greenery, it’s ideal for guests who wish to relax while respecting the environment."
  },
  {
    question: "How far is Woodland Escape Resort from Nagpur city?",
    answer: "The resort is located within reachable driving distance from Nagpur city in Nagpur district, making it easy to access while still offering a tranquil and eco‑friendly retreat away from the urban bustle."
  },
  {
    question: "What eco‑friendly facilities does Woodland Escape Resort offer?",
    answer: "The resort provides amenities such as nature‑view rooms, open green areas, energy‑efficient lighting, possibly rain‑water harvesting or sustainable landscaping, and outdoor spaces that invite minimal‑impact stays in nature."
  },
  {
    question: "Is Woodland Escape Resort suitable for families or couples who also value sustainability?",
    answer: "Absolutely! The resort is designed for guests who appreciate nature and comfort — from families to couples — offering safe and relaxing spaces amidst greenery, with an eco‑friendly mindset woven into the stay."
  },
  {
    question: "Does the resort provide food and services aligned with eco‑friendly values?",
    answer: "Yes. Woodland Escape Resort offers freshly prepared meals, snacks and beverages, and uses practices that complement the eco‑friendly stay such as thoughtfully managed waste, natural surroundings and possibly locally sourced provisions."
  },
  {
    question: "How can we book Woodland Escape Resort for an eco‑friendly stay in Nagpur district?",
    answer: "You can book by calling or sending a WhatsApp message to the resort’s reservations team, or by visiting their official website. Booking in advance is recommended—especially for weekends and holiday periods."
  }
];

const testimonials = [
  {
    name: "Mr. Rajesh & Family, Nagpur",
    text: "Our stay at Woodland Escape Resort was wonderful! The natural surroundings, green spaces and calm environment made it a refreshing eco‑friendly escape in Nagpur district."
  },
  {
    name: "Ms. Anjali & Friends, Nagpur",
    text: "We loved our weekend at Woodland Escape Resort. The greenery, the feeling of being close to nature, and the resort’s relaxed sustainable atmosphere made it very special."
  }
];































      






  const carouselItems = testimonials.map(testimonial => (
    <div key={testimonial.name}>
      <blockquote>

        <p className='testi'>   <span className="quote">“</span>{testimonial.text}</p>
        <footer className=' user'>— {testimonial.name}</footer>
      </blockquote>
    </div>
  ));

  const carouselOptions = {
    loop: true,
    margin: 10,
    nav: true,
    items: 1
  };

  const contactData = {
    heading: `${cardData.keyword} Contact Number`,
    contactNumbers: [
      "+91 9175577266",

    ],
    email: "woodlandescape01@gmail.com"
  };


  const Images = [
  { place: "/images/keyword/1.jpg", text: "1 day tour near Nagpur", link: "1-day-tour-near-Nagpur" },
  { place: "/images/keyword/2.jpg", text: "Best picnic spot near Nagpur", link: "best-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/3.jpg", text: "Family picnic spot near Nagpur", link: "family-picnic-spot-near-Nagpur" },
  { place: "/images/keyword/4.jpg", text: "Nearest picnic spot in Nagpur", link: "nearest-picnic-spot-in-Nagpur" },
  { place: "/images/keyword/5.jpg", text: "Destination wedding spots near Nagpur", link: "destination-wedding-spots-near-Nagpur" },
  { place: "/images/keyword/6.jpg", text: "Pre wedding destination near Nagpur", link: "pre-wedding-destination-near-Nagpur" },
  { place: "/images/keyword/7.jpg", text: "One day adventure resorts near Nagpur", link: "one-day-adventure-resorts-near-Nagpur" },
  { place: "/images/keyword/8.jpg", text: "Activities resort near Nagpur", link: "activities-resort-near-Nagpur" },
  { place: "/images/keyword/9.jpg", text: "Best picnic spot near Akola", link: "best-picnic-spot-near-Akola" },
  { place: "/images/keyword/10.jpg", text: "One day tour near Akola", link: "one-day-tour-near-Akola" },
  { place: "/images/keyword/11.jpg", text: "Resorts near Akola for family", link: "resorts-near-Akola-for-family" },
  { place: "/images/keyword/12.jpg", text: "Destination wedding resorts near Akola", link: "destination-wedding-resorts-near-Akola" },
  { place: "/images/keyword/13.jpg", text: "Best picnic spot near Amravati", link: "best-picnic-spot-near-Amravati" },
  { place: "/images/keyword/14.jpg", text: "One day tour near Amravati", link: "one-day-tour-near-Amravati" },
  { place: "/images/keyword/15.jpg", text: "Family resorts near Amravati", link: "family-resorts-near-Amravati" },
  { place: "/images/keyword/16.jpg", text: "Pre-wedding location near Amravati", link: "pre-wedding-location-near-Amravati" },
  { place: "/images/keyword/17.jpg", text: "Picnic spot near Bhandara", link: "picnic-spot-near-Bhandara" },
  { place: "/images/keyword/18.jpg", text: "One day trip near Bhandara", link: "one-day-trip-near-Bhandara" },
//   { place: "/images/keyword/19.jpg", text: "Resorts near Bhandara for family outing", link: "resorts-near-Bhandara-for-family-outing" },
//   { place: "/images/keyword/20.jpg", text: "Destination wedding place near Bhandara", link: "destination-wedding-place-near-Bhandara" },
//   { place: "/images/keyword/21.jpg", text: "Best picnic spot near Buldhana", link: "best-picnic-spot-near-Buldhana" },
//   { place: "/images/keyword/22.jpg", text: "One day tour near Buldhana", link: "one-day-tour-near-Buldhana" },
//   { place: "/images/keyword/23.jpg", text: "Family resorts near Buldhana", link: "family-resorts-near-Buldhana" },
//   { place: "/images/keyword/24.jpg", text: "Wedding destination near Buldhana", link: "wedding-destination-near-Buldhana" },
//   { place: "/images/keyword/25.jpg", text: "Picnic spot near Chandrapur", link: "picnic-spot-near-Chandrapur" },
];



  const images = [
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/2.jpg", alt: "Image 1" },
    { src: "/images/galleryy/3.jpg", alt: "Image 1" },
    { src: "/images/galleryy/4.jpg", alt: "Image 1" },
    { src: "/images/galleryy/5.jpg", alt: "Image 1" },
    { src: "/images/galleryy/6.jpg", alt: "Image 1" },
    { src: "/images/galleryy/7.jpg", alt: "Image 1" },
    { src: "/images/galleryy/8.jpg", alt: "Image 1" },
    { src: "/images/galleryy/9.jpg", alt: "Image 1" },
  ];

const ecoResortSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Eco-Friendly Resort in Nagpur District",
  "image": "https://woodlandescape.com/assets/images/nagpur-eco-resort.jpg",
  "description": "Stay at our Eco-Friendly Resort in Nagpur District and experience sustainable luxury surrounded by nature. Ideal for families, couples, and adventure seekers, with forest, hill, and riverside views.",
  "brand": {
    "@type": "Brand",
    "name": "Woodlandescape Resort"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "35"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "7499",
    "availability": "https://schema.org/InStock",
    "url": "https://woodlandescape.com/nagpur-eco-resort"
  }
};



  return (
    <div>

<Helmet>
  <title>Eco-Friendly Resort in Nagpur District | Woodlandescape Resort</title>
  <meta 
    name="description" 
    content="Enjoy a sustainable stay at our Eco-Friendly Resort in Nagpur District with forest, riverside, and hill views. Perfect for families, couples, and eco-conscious travelers." 
  />
  <meta 
    name="keywords" 
    content="Eco-Friendly Resort in Nagpur District, Nagpur Green Resort, Nagpur Sustainable Nature Resort, Nagpur Eco Luxury Stay, Nagpur Forest Eco Resort, Nagpur Riverside Eco Resort, Nagpur Adventure Eco Resort, Nagpur Family Eco Resort, Nagpur Kids Friendly Eco Resort, Nagpur Jungle Eco Resort, Nagpur Weekend Eco Resort, Nagpur Booking Eco-Friendly Resort, Nagpur Hill Eco Resort, Nagpur Private Eco Stay, Nagpur Nature-Friendly Resort" 
  />
  <script type="application/ld+json">
    {JSON.stringify(ecoResortSchema)}
  </script>
</Helmet>

   <section
  className="page-title"
  style={{
    backgroundImage: `
      linear-gradient(
        rgba(0, 0, 0, 0.6),
        rgba(0, 0, 0, 0.6)
      ),
      url(/images/page-title.jpg)
    `,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  <div className="auto-container">
    <div className="text-center">
            <h1>{cardData.keyword}</h1>
    </div>
  </div>
</section>

  


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-8 ">
              <img src='/images/keyword/53.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#2AA248', // green color
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className=' leadd'>{cardData.headingDescription}</p>
              <div className="">
                <p className='fw-bold py-3'>{cardData.top}</p>
                {cardData.topPlaces.map((place, index) => (
                  <div key={index} className="">
                    <div
                      style={{
                        cursor: 'pointer',
                        padding: '10px',
                        marginBottom: '7px',
                        borderRadius: '8px', // Optional: rounded corners
                        transition: 'transform 0.2s' // Optional: smooth scaling effect
                      }}
                    // Centers text within the card
                    >
                      <h4 className="mb-1 darkcolor">{place.title}</h4>
                      <p className="mb-0">{place.description}</p>
                    </div>
                  </div>
                ))}
              </div>
              <div
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  marginBottom: '7px',
                  borderRadius: '8px', // Optional: rounded corners
                  transition: 'transform 0.2s' // Optional: smooth scaling effect
                }}
              >
                {cardData.services.map((service, index) => (
                  <div key={index} className=" my-4">
                    <h4 className="py-1 darkcolor">{service.name}</h4>
                    <p>{service.description}</p>
                  </div>
                ))}
              </div>


              <div id="why-choose-section"
                className='px-2'>
                {cardData.whychoose.map((item, index) => (
                  <div key={index}>
                    <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                    <p>{item.WhyChoosedescription}</p>
                  </div>
                ))}
              </div>


              <div>

              </div>


            </div>

            <div className='col-12 col-md-4' >


              <div className=" rounded p-4 shadow-sm Uni_border"
                style={{
                  cursor: 'pointer',
                  padding: '10px',
                  border: '3px dotted #2AA248',
                  marginBottom: '7px',
                  fontWeight: 'bold',
                }}

              >
                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                <div className="row">

                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#2AA248' }}>
                      <h4 className=" lead fw-semibold whitt">Phone Numbers</h4>
                      <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                      <div className=''>
                        <a href="tel:+91 9175577266" className="d-block  text-white">+91 9175577266</a>

                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3 ">
                    <div className="Small_border rounded text-center">
                      <i className="bi bi-envelope fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Email</h4>
                        <a href="mailto:woodlandescape01@gmail.com" className=" text-white d-block">
                          woodlandescape01@gmail.com
                        </a>
                      </div>
                    </div>
                  </div>


                  <div className="col-12 mb-3">
                    <div className="Small_border  rounded text-center">
                      <i className="bi bi-house-fill fs-1 mb-2"></i>
                      <div className='rounded py-2' style={{ backgroundColor: '#2AA248' }}>
                        <h4 className=" fw-semibold lead whitt">Address</h4>
                        <p className="whit text-white ">
                          <i> Woodland Escape Resort:<br />
                            Wadamba, Behind St. Peters School, Deolapar, Dist. Nagpur - <br />441401

                          </i>
                        </p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>


              {/* {Images.map((e) => {
                return (
                  <div className="box1">
                    <a
                      href="./"
                      className="d-flex justify-content-around align-items-center"
                    >
                      <div className="b1">
                        <img src={e.place} alt="img" />
                      </div>
                      <div className="b2">
                        {" "}
                        <a href="./" className='darkcolorr'>{e.text}</a>
                      </div>
                    </a>
                  </div>
                );
              })} */}


              
{Images.map((e, index) => {
  return (
    <div className="box1" key={index}>
      <a
        href={`/${e.link}`}
        className="d-flex justify-content-around align-items-center"
      >
        <div className="b1">
          <img src={e.place} alt={e.text} />
        </div>
        <div className="b2 darkcolorr">
          {e.text}
        </div>
      </a>
    </div>
  );
})}



             <Gallery images={images} ></Gallery>
              <table className="table table-responsive custom-table my-4">
                <thead>
                  <tr>
                    {cardData?.tableHeaders?.map((header, index) => (
                      <th key={index} className="custom-th">{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {cardData?.tableData?.map((row, rowIndex) => (
                    <tr className="custom-row" key={rowIndex}>
                      {row?.map((cell, cellIndex) => (
                        <td key={cellIndex} className="custom-td">
                          {cell}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>


              <div>
                <h3 className='Colo'>FAQs {cardData.keyword} for Woodland Escape Resort</h3>
                <Accordion data={faqData} />
              </div>
              <div className='py-3'>
                <CustomCarousel items={carouselItems} options={carouselOptions} />
              </div>


              {/* <div className="contact-box Borderr mt-5">
                <h3>{contactData.heading}</h3>
                <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                <div className="contact-details">
                  <p><strong className='darkcolor'>Mobile No:</strong></p>
                  <ul>
                    {contactData.contactNumbers.map((number, index) => (
                      <li key={index}>
                        <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                          {number}
                        </a>
                      </li>
                    ))}
                  </ul>

                  <p><strong className='darkcolor'>Email Id: </strong>
                    <a href={`mailto:${contactData.email}`} className="contact-link">
                      {contactData.email}
                    </a>
                  </p>
                </div>
              </div> */}
<div className="contact-box woodland-theme mt-5">
  <h3 className="heading">{contactData.heading}</h3>
  <p className="subtext">
    For booking inquiries or any assistance, please feel free to contact us:
  </p>

  <div className="contact-details">
    <p className="label">📞 Mobile No:</p>
    <ul className="number-list">
      {contactData.contactNumbers.map((number, index) => (
        <li key={index}>
          <a href={`tel:${number}`} className="contact-link">
            {number}
          </a>
        </li>
      ))}
    </ul>

    <p className="label">📧 Email Id:</p>
    <a href={`mailto:${contactData.email}`} className="contact-link email-link">
      {contactData.email}
    </a>
  </div>
</div>



            </div>
            {/* <BusRatesTable /> */}
          </div>
        </div>
      </section>






    </div>
  );
}

export default Ecofriendlyresortinnagpurdistrict;